import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/announcement',
  title: window.language['menu.sysConfig.announcement'],
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/NavBar/SystemNotice/index.js